"use strict";

var _classCallCheck = require("/opt/build/repo/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/opt/build/repo/node_modules/@babel/runtime/helpers/createClass");

require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Lighter = void 0;

var Utils_1 = require("../../Utils");

var Modes_1 = require("../../Enums/Modes");

var Lighter = /*#__PURE__*/function () {
  function Lighter(container) {
    _classCallCheck(this, Lighter);

    this.container = container;
  }

  _createClass(Lighter, [{
    key: "interact",
    value: function interact(particle) {
      var container = this.container;
      var options = container.options;

      if (options.interactivity.events.onHover.enable && container.interactivity.status === "mousemove") {
        var mousePos = this.container.interactivity.mouse.position;

        if (mousePos) {
          container.canvas.drawParticleShadow(particle, mousePos);
        }
      }
    }
  }, {
    key: "isEnabled",
    value: function isEnabled() {
      var container = this.container;
      var mouse = container.interactivity.mouse;
      var events = container.options.interactivity.events;

      if (!(events.onHover.enable && mouse.position)) {
        return false;
      }

      var hoverMode = events.onHover.mode;
      return Utils_1.Utils.isInArray(Modes_1.HoverMode.light, hoverMode);
    }
  }, {
    key: "reset",
    value: function reset() {}
  }]);

  return Lighter;
}();

exports.Lighter = Lighter;